export const getUnreads = (thread, isFactory) => {
  return !isFactory ? thread.unreads[0] : thread.unreads[1];
};
